<template>
    <div>
        <v-card>
            <v-card-title>
                Donors
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-btn small style='margin-top : 15px; margin-right : 15px' @click='downloadCSV'>Download CSV</v-btn>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table v-model='selected' :headers="headers" :items="donors" :search="search">
            </v-data-table>
        </v-card>
    
    
    </div>
</template>

<script>
import papa from 'papaparse'
import moment from "moment"
const fb = require("../../firebaseconfig");
export default {
    data() {
        return {
            dialog: false,
            selected: [],
            headers: [
                { text: 'Id', value: 'id' },
                { text: 'Name', value: 'name' },
                { text: 'Email', value: 'email' },
                { text: 'Address', value: 'address' },
                { text: 'City', value: 'city' },
                { text: 'State', value: 'state' },
                { text: 'ZipCode', value: 'zip' },
            ],
            search: null,
            donations: null,
            ngo: [],
            donors: [],
        }
    },
    async mounted() {
        fb.auth.currentUser.getIdTokenResult()
            .then(async (idTokenResult) => {
                await this.getDonors(idTokenResult.claims.npo);
            })

    },
    methods: {
          downloadCSV(){
      let csv = papa.unparse(this.donors);
      var csvData = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
    var csvURL =  null;
    if (navigator.msSaveBlob)
    {
        csvURL = navigator.msSaveBlob(csvData, 'download.csv');
    }
    else
    {
        csvURL = window.URL.createObjectURL(csvData);
    }

    var tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', 'download.csv');
    tempLink.click();
    },
        goTo(item) {
            this.$router.push("/donations/" + item.id);
        },
        dayElapsed(time) {
            if (time) {
                return "(" + moment().diff(time, 'days') + "days old)";
            } else {
                return "Not yet received"
            }

        },

        async getDonors() {
            await fb.db.collection("donors").onSnapshot((query) => {
                this.donors = [];
                query.forEach(donor => {
                    this.donors.push(donor.data())
                })
            });

        }
    }
}
</script>